import { useAiUsageQuery } from "@/api/usage";
import { Ribbon, SectionHeader } from "@/components/ui";
import { t } from "@/i18n";
import { fmtInt, fmtMoney } from "@/lib/utils";

interface UsagePanelProps {
  month: string;
}

/** Aylik AI kullanim/maliyet — GET /api/v2/usage/ai (gorev talimati madde 5).
 * `tenant_id` verilmez → suPER icin TUM tenant'larin toplami (backend
 * app/core/api/usage.py: `principal.is_super` + tenant_id=None). */
export function UsagePanel({ month }: UsagePanelProps) {
  const usageQuery = useAiUsageQuery(month);

  return (
    <section className="space-y-2">
      <SectionHeader title={t("admin.usage.title")} note={month} />
      {usageQuery.isLoading && <p className="text-sm text-muted">{t("common.loading")}</p>}
      {usageQuery.isError && <Ribbon tone="bad">{t("common.error")}</Ribbon>}
      {usageQuery.data && (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          <div className="kpi">
            <p className="kpi-lbl">{t("admin.usage.calls")}</p>
            <p className="kpi-val">{fmtInt(usageQuery.data.calls)}</p>
          </div>
          <div className="kpi">
            <p className="kpi-lbl">{t("admin.usage.tokens")}</p>
            <p className="kpi-val !text-xl">
              {fmtInt(usageQuery.data.tokens_in)} / {fmtInt(usageQuery.data.tokens_out)}
            </p>
          </div>
          <div className="kpi">
            <p className="kpi-lbl">{t("admin.usage.cost")}</p>
            <p className="kpi-val">{fmtMoney(usageQuery.data.cost_try)}</p>
          </div>
        </div>
      )}
    </section>
  );
}
